

export class NotificationUserDto implements INotificationUserDto {
    id!: number;
    userId!: number;
    notificationTypeId!: number;

    constructor(data?: INotificationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.notificationTypeId = _data["notificationTypeId"];
        }
    }

    static fromJS(data: any): NotificationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["notificationTypeId"] = this.notificationTypeId;
        return data; 
    }
}

export interface INotificationUserDto {
    id: number;
    userId: number;
    notificationTypeId: number;
}

